import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { keys, omit } from 'lodash-es';
import { FilterPickerGroup, useDevice } from 'seagull';
import { useTableListContext } from 'seagull/components/TableList/TableList.utils';
import AddFilter from './AddFilter/AddFilter';
import Filter from './Filter/Filter';
import { MobileTableFilters } from './MobileTableFilters/MobileTableFilters';
import { isInitialFilterValue, makeInitialFilterValue } from './TableFilters.utils';
const DesktopTableFilters = (param)=>{
    let { testIdPrefix, filterLabels, filterConfig, selectedFilters, onRefresh, setSelectedFilters, filterGroups, alwaysShowAllFilters, disableFlexWrap, onInputFocus, onInputBlur, onClear, isClearDisabled } = param;
    const { sort } = useTableListContext();
    const visibleFilterKeys = alwaysShowAllFilters ? filterGroups ? filterGroups.flatMap((group)=>group.filters) : keys(filterConfig) : keys(selectedFilters);
    const onChange = (filter, value)=>{
        const newSelectedFilters = _object_spread_props(_object_spread({}, selectedFilters), {
            [filter]: value
        });
        onRefresh(newSelectedFilters, sort);
        setSelectedFilters(newSelectedFilters);
    };
    const onRemove = (filterToRemove)=>{
        const selectedFilterValue = selectedFilters[filterToRemove];
        const newSelectedFilters = omit(selectedFilters, filterToRemove);
        if (!isInitialFilterValue(selectedFilterValue, filterConfig[filterToRemove])) onRefresh(newSelectedFilters, sort);
        setSelectedFilters(newSelectedFilters);
    };
    const onSelect = (filter)=>{
        setSelectedFilters(_object_spread_props(_object_spread({}, selectedFilters), {
            [filter]: makeInitialFilterValue(filterConfig[filter])
        }));
    };
    return /*#__PURE__*/ _jsxs(FilterPickerGroup, {
        flexWrap: !disableFlexWrap,
        testId: "".concat(testIdPrefix, "-filters"),
        onClearClick: onClear,
        disableClear: isClearDisabled,
        children: [
            visibleFilterKeys.map((filter)=>{
                var _selectedFilters_filter;
                return /*#__PURE__*/ _jsx(Filter, {
                    label: filterLabels[filter],
                    filter: filter,
                    selectedFilter: (_selectedFilters_filter = selectedFilters[filter]) !== null && _selectedFilters_filter !== void 0 ? _selectedFilters_filter : makeInitialFilterValue(filterConfig[filter]),
                    testIdPrefix: testIdPrefix,
                    onChange: (value)=>onChange(filter, value),
                    onRemove: ()=>onRemove(filter),
                    filterConfig: filterConfig[filter],
                    onInputFocus: onInputFocus,
                    onInputBlur: onInputBlur
                }, String(filter));
            }),
            !alwaysShowAllFilters && keys(selectedFilters).length < keys(filterConfig).length && /*#__PURE__*/ _jsx(AddFilter, {
                filtersMap: filterLabels,
                testId: testIdPrefix,
                selectedFilters: keys(selectedFilters),
                onSelect: onSelect,
                groups: filterGroups
            })
        ]
    });
};
function TableFilters(props) {
    const { isMobileDevice } = useDevice();
    return isMobileDevice ? /*#__PURE__*/ _jsx(MobileTableFilters, _object_spread({}, props)) : /*#__PURE__*/ _jsx(DesktopTableFilters, _object_spread({}, props));
}
export default TableFilters;
